<template>
    <div>
        <div class="tabs-wrap">
            <div class="tab-content">
                <div class="category">
							<span class="opener-text">
								<span class="text">Recommended</span>
							</span>
                </div>
                <ul class="tab-subtab">
                    <li>
                        <a href="javascript:;" @click="subTabActive('tab1')" class="added">
									<span class="tablist-opener-text">
										<span>link 1</span>
										<span class="notification">
											<span class="check"><svg aria-hidden="true" width="19" height="14"
                                                                     viewBox="0 0 20 15" focusable="false"><g><path
                                                    d="M6.66667 14.4999L20 1.51381L18.7879 0.333252L6.61397 12.1901L1.15942 6.87764L0 8.00686L6.66667 14.4999Z"></path></g></svg></span>
											<span>Added</span>
										</span>
									</span>
                            <span class="forward"><svg aria-hidden="true" width="20" height="20"
                                                       viewBox="0 0 20 20" focusable="false"><g><path
                                    d="M15 10l-8.202 8.333-.965-.98L13.07 10 5.833 2.647l.965-.98L15 10Z"></path></g></svg></span>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:;" @click="subTabActive('tab2')">
									<span class="tablist-opener-text">
										<span>link 2</span>
										<span class="notification">
											<span class="check"><svg aria-hidden="true" width="19" height="14"
                                                                     viewBox="0 0 20 15" focusable="false"><g><path
                                                    d="M6.66667 14.4999L20 1.51381L18.7879 0.333252L6.61397 12.1901L1.15942 6.87764L0 8.00686L6.66667 14.4999Z"></path></g></svg></span>
											<span>Added</span>
										</span>
									</span>
                            <span class="forward"><svg aria-hidden="true" width="20" height="20"
                                                       viewBox="0 0 20 20" focusable="false"><g><path
                                    d="M15 10l-8.202 8.333-.965-.98L13.07 10 5.833 2.647l.965-.98L15 10Z"></path></g></svg></span>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:;" @click="subTabActive('tab3')">
									<span class="tablist-opener-text">
										<span>link 3</span>
										<span class="notification">
											<span class="check"><svg aria-hidden="true" width="19" height="14"
                                                                     viewBox="0 0 20 15" focusable="false"><g><path
                                                    d="M6.66667 14.4999L20 1.51381L18.7879 0.333252L6.61397 12.1901L1.15942 6.87764L0 8.00686L6.66667 14.4999Z"></path></g></svg></span>
											<span>Added</span>
										</span>
									</span>
                            <span class="forward"><svg aria-hidden="true" width="20" height="20"
                                                       viewBox="0 0 20 20" focusable="false"><g><path
                                    d="M15 10l-8.202 8.333-.965-.98L13.07 10 5.833 2.647l.965-.98L15 10Z"></path></g></svg></span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="subtab-content">
                <div class="back-holder">
                    <a href="javascript:;" class="btn-back" @click="closeSubTab('data-tab')">
                                <span class="back"><svg aria-hidden="true" width="10" height="16" viewBox="0 0 320 512"
                                                        focusable="false" class="fa-icon"><g><path
                                        d="M34.5 239l194.4-194.3c9.4-9.4 24.6-9.4 33.9 0l22.7 22.7c9.4 9.4 9.4 24.5 0 33.9l-154 154.7 154 154.8c9.3 9.4 9.3 24.5 0 33.9l-22.7 22.7c-9.4 9.4-24.6 9.4-33.9 0l-194.3-194.4c-9.4-9.4-9.4-24.6 0-33.9z"></path></g></svg></span>
                        <span>Back</span>
                    </a>
                </div>
                <div class="tab" data-tab="tab1">
                    <div class="tab-text-info">
                        <h3>Nationality</h3>
                        <p>Participants were asked the following question: What is your nationality?</p>
                        <p>Please note: participants can only choose one nationality for this question. If you
                            want to recruit based on country of residence, please use the ‘Current Country of
                            Residence’ filter instead.</p>
                        <p>Select the required responses or <a href="javascript:;">select all</a></p>
                    </div>
                    <b-form-input
                            v-model="modalTabSearch"
                            type="search"
                            required
                            class="subtab-search"
                            placeholder="Type to search..."
                    ></b-form-input>
                    <ul class="tab-subtab">
                        <li>
                            <b-form-checkbox
                                    v-model="checkbox"
                                    value="1"
                            >
                                Some Text of checkbox
                                <span class="selected"><svg aria-hidden="true" width="14" height="14"
                                                            viewBox="0 0 512 512" focusable="false"
                                                            class="fa-icon"><g><path
                                        d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"></path></g></svg></span>
                            </b-form-checkbox>
                        </li>
                        <li>
                            <b-form-checkbox
                                    v-model="checkbox"
                                    value="2"
                            >
                                Some Text of checkbox
                                <span class="selected"><svg aria-hidden="true" width="14" height="14"
                                                            viewBox="0 0 512 512" focusable="false"
                                                            class="fa-icon"><g><path
                                        d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"></path></g></svg></span>
                            </b-form-checkbox>
                        </li>
                    </ul>
                </div>
                <div class="btns-holder">
                    <div class="btns-box">
                        <a href="javascript:;" class="btn btn-cancel btn-sm">Remove</a>
                        <span class="notification">
												<span class="check"><svg aria-hidden="true" width="19" height="14"
                                                                         viewBox="0 0 20 15" focusable="false"><g><path
                                                        d="M6.66667 14.4999L20 1.51381L18.7879 0.333252L6.61397 12.1901L1.15942 6.87764L0 8.00686L6.66667 14.4999Z"></path></g></svg></span>
												<span>Removed</span>
											</span>
                    </div>
                    <div class="btns-box">
											<span class="notification">
												<span class="check"><svg aria-hidden="true" width="19" height="14"
                                                                         viewBox="0 0 20 15" focusable="false"><g><path
                                                        d="M6.66667 14.4999L20 1.51381L18.7879 0.333252L6.61397 12.1901L1.15942 6.87764L0 8.00686L6.66667 14.4999Z"></path></g></svg></span>
												<span>Applied</span>
											</span>
                        <a href="javascript:;" class="btn btn-primary btn-sm submit">Apply</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
    }
</script>

<style scoped>

</style>